import { render, staticRenderFns } from "./SalonTipos.vue?vue&type=template&id=08652a4a&"
import script from "./SalonTipos.vue?vue&type=script&lang=js&"
export * from "./SalonTipos.vue?vue&type=script&lang=js&"
import style0 from "./SalonTipos.vue?vue&type=style&index=0&id=08652a4a&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports